import React, { FC } from 'react';
import styled from 'styled-components';
import { NgPageTitle } from '../NgPageTitle/NgPageTitle';

const StyledRibbon = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.large};
  min-height: 60px;

  > div:first-child {
    flex-grow: 1;
  }

  > div:nth-child(2) {
    flex-shrink: 0;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const NgRibbon: FC<{ ribbonData: INgRibbonProps }> = ({ ribbonData: { title, actions } }) => (
  <StyledRibbon>
    <div>
      <NgPageTitle title={title} />
    </div>
    <div>{actions}</div>
  </StyledRibbon>
);
